// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { IEnvironment } from 'libs/core/src/lib/_environment/interface';

export const environment: IEnvironment = {
  production: false,
  app: {
    mode: 'webpage',
    assetsPath: ''
  },
  projectName: 'cinema1',
  siteUrl: 'https://www.cinema1.pl/{0}',

  apiUrl: 'http://localhost:8000/api',
  backUrl: 'http://localhost:4200/screening',
  internationalPhone: {
    definitionUrl: '/assets/data/phone/list.json'
  },
  metadata: {
    title: 'Cinema1'
  },
  startOnPlayground: false,
  tagManager: {
    providers: []
  },
  paymentManager: {},
  virtualCinema: {
    enabled: false,
    list: [
      {
        name: null,
        translate: true,
        constraints: {
          screenId: null
        }
      }
    ]
  },
  activeLogger: true,
  constants: {
    checkByButton: false,
    eventScreenEnabled: true,
    clearMessageOnPageChange: true,
    saveCurrentUrlToCookie: true,
    tokenToCookie: true,
    moviePosterPlaceholder: '/assets/images/poster_default.png',
    moviePicturePlaceholder: '/assets/images/picture_default.png',
    moviePosterPlaceholderOnError: true,
    currency: 'PLN',
    ticketVatRate: 5,
    paymentChannel: 'web',
    paymentRedirectUrl: null,
    createOrderOnGeneralAdmission: true,
    deleteOrderOnWindowUnload: true,
    maxSelectedTickets: 10,
    maxPhoneNumberLength: null,
    phoneNumberTrimLeadingZeros: false,
    paymentDebug: false,
    country: 'PL',
    language: {
      default: 'pl',
      available: ['pl'],
      cultureMap: [{ key: 'pl', value: 'pl-PL' }],
      useLangAsUrlParam: true
    },
    allowedPages: [
      'screening',
      'screen',
      'personalAndPayment',
      'summary',
      'userRegister',
      'userLogin',
      'userRemind',
      'userSetPassword',
      'userMyProfile',
      'userAreaLogin',
      'userAreaMyProfile',
      'userAreaRegister',
      'userAreaUserRemind',
      'userAreaUserSetPassword',
      'userAreaUserRegisterConfirmation',
      'userAreaError',
      'userAreaMessage',
      'userLogout',
      'userAreaUserLogout',
      'userAreaMyBookings',
      'userMyBookings',
      'userPreferences',
      'userAreaUserPreferences',
      'user',
      'basket',
      'payment',
      'foodandbeverage',
      'tickets',
      'personal'
    ],
    excludeMessageOnPages: ['userRegister', 'userLogin', 'userAreaLogin', 'userAreaRegister', 'screen'],
    excludeTtlErrorOnPages: ['user', 'refund', 'summary', 'error'],
    disableOrderValidationOnPage: ['summary'],
    screenMovieComponentOnPage: ['screen', 'basket', 'payment', 'summary'],
    autoSelectPaymentMethod: 'przelewy24',
    allowedPaymentMethod: ['przelewy24'],
    countdownStartInit: 600,
    enableMultipleScreeningSales: false,
    basketMaxScreenings: 1,
    cartEnabled: false,
    defaultCinemaId: null,
    defaultRegionId: null,
    voucherSaleEnabled: false,
    voucherLimitPerTransaction: 1,
    forceOptionalFees: true,
    recaptcha: {
      enabled: false,
      siteKey: 'YOUR_SITE_KEY'
    },
    phoneProviderNumbers: [],
    expiryLimit: {
      years: 1
    },
    userDataChecklist: [],
    localStorageStrategy: {
      maxAge: 86400000,
      maxCacheCount: 5
    }, // used in decorator! can't override by config!
    reservationTimeControlMode: 'reduce',
    enableFB: false
  },
  screen: {
    enableSeatTooltip: false,
    showPopupOnSelectedSeat: true,
    reduceRequestsForScreeningItems: true,
    reduceRequestsForTicket: true,
    periodBetweenRequestsInScreen: 500,
    removeOrderWhenUserLeavePage: true,
    seatPopup: {
      groupTypesFilter: ['wheelchair']
    }
  },
  postprocesorUrl: '',
  header: {
    actionButtonList: {
      action1: {
        action: {
          nextRouteFor: 'foodandbeverage'
        }
      }
    }
  },
  pages: {
    optionalExtraFeeSelection: 'all',
    screening: {
      enabled: true,
      days: 7,
      defaultStartDate: null,
      showOnlyGeneralAdmission: false,
      navigation: {
        previous: '',
        next: ''
      }
    },
    screen: {
      maxSeats: 5,
      navigation: {
        previous: 'screening',
        next: 'basket'
      },
      autoChooseTicket: false,
      withTicketCompose: false,
      priceSeparators: false,
      showNoticeOnCollisionWithOtherScreenings: false, // applies only for general admission, cart need to be enabled
      redirectToErrorPageSwapScreen: true,
      legend: {
        sort: ['free', 'occupied', 'mine', 'wheelchair', 'wheelchairwithseat', 'handicapplace', 'handicapseat', 'couch', 'companion', 'exit']
      }
    },

    personalAndPayment: {
      navigation: {
        previous: 'screen',
        next: 'order/summary'
      }
    },
    paymentstate: {
      navigation: {
        next: 'order/summary'
      }
    },
    basket: {
      enabledHeliosVoucher: false,
      maxScreenings: 1,
      maxSeats: 1,
      showAgreements: false,
      autoStartPayment: false,
      enabledWarningModalOnNextAction: true,
      ticketList: {
        sortStrategy: 'price_desc', // none, price_desc, price_asc,
        defaultTicket: 'first_price_desc' // first, first_price_desc, first_price_asc, last
      },
      navigation: {
        previous: 'screen',
        next: 'foodandbeverage',
        target: {
          skip: 'personal',
          continue: 'foodandbeverage'
        }
      }
    },
    foodandbeverage: {
      showScreeningInfo: true,
      navigation: {
        previous: 'basket',
        next: 'payment'
      },
      target: {}
    },
    personal: {
      navigation: {
        previous: (previous) => {
          return previous.giftCardTransaction === true ? 'gc' : previous.flowType === 'tickets' ? 'tickets' : 'basket';
        },
        next: 'payment'
      }
    },
    payment: {
      navigation: {
        previous: (params) => {
          return params.cateringSaleEnabled === true ? 'foodandbeverage' : 'personal';
        },
        next: 'order/summary'
      }
    },
    tickets: {
      navigation: {
        previous: '',
        next: 'personal'
      }
    }
  },
  theme: {
    name: 'cinema1',
    assetsDir: 'assets'
  },
  imdb: {
    url: 'https://www.imdb.com/title/'
  },
  scripts: {
    apiKeys: {}
  },
  loader: {
    backdropBorderRadius: '0px',
    backdropBackgroundColour: 'rgba(200, 200, 200, 0.5)',
    fullScreenBackdrop: false,
    animationType: 'three-bounce',
    primaryColour: '#95C11F',
    secondaryColour: '#0E121B',
    tertiaryColour: '#D0D5DD',
    style: null,
    size: null
  },
  virtualPass: ['apple'],
  placeholder: {
    picture: '/assets/images/poster_default.png',
    poster: '/assets/images/poster_default.png',
    square: '/assets/images/poster_default.png',
    card: '/assets/images/poster_default.png',
    default: '/assets/images/poster_default.png'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
